
/**
 * SEO 配置 - models (Русский)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Флагманский генератор видео ИИ | WeryAI',
        description: 'Google Veo 3.1: Флагманская модель видео ИИ с нативным аудио и управлением кадрами.',
        keywords: 'Google Veo 3.1, видео ИИ, генератор видео, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - Генерация видео ИИ высокого качества | WeryAI',
        description: 'Попробуйте Veo 3 на WeryAI. Высококачественные результаты.',
        keywords: 'Veo 3, Google Veo, видео ИИ, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - Сверхбыстрая генерация видео ИИ | WeryAI',
        description: 'Попробуйте Veo 3 Fast на WeryAI. Быстрые и качественные результаты.',
        keywords: 'Veo 3 Fast, быстрое видео ИИ, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Реалистичный генератор видео ИИ | WeryAI',
        description: 'Попробуйте Sora 2 на WeryAI. Высококачественные результаты.',
        keywords: 'Sora 2, OpenAI Sora, видео ИИ, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Генератор видео ИИ | WeryAI',
        description: 'Попробуйте WeryAI Video 1.0 для создания кинематографических видео ИИ.',
        keywords: 'WeryAI Video 1.0, видео ИИ, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Нативный ИИ генератор изображений | WeryAI',
        description: 'Используйте WeryAI Image 2 для потрясающей нативной генерации ИИ-изображений! Флагманская модель с продвинутым контролем стиля. Бесплатные кредиты, карта не нужна.',
        keywords: 'WeryAI Image 2, нативный ИИ генератор, флагманский ИИ, студийное качество ИИ, WeryAI Image бесплатно, как использовать WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Бесплатно Grok 2 - xAI генератор изображений | WeryAI',
        description: 'Используйте Grok 2 на WeryAI для создания креативных ИИ-изображений! Модель xAI с художественной гибкостью и уникальными стилями. Бесплатные кредиты, карта не нужна.',
        keywords: 'Grok 2, Grok AI, xAI генератор, ИИ-арт, креативные ИИ изображения, Grok 2 бесплатно, как использовать Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Генератор изображений | WeryAI',
        description: 'Nano Banana 2 на базе Gemini с мировыми знаниями и поиском в реальном времени. Создавайте фактически точные и потрясающие изображения на сверхвысокой скорости.',
        keywords: 'Nano Banana 2, Google AI, Gemini, генерация изображений, рендеринг текста, согласованность нескольких объектов, 4K, WeryAI',
        og_title: 'Nano Banana 2 Генератор изображений | WeryAI',
        og_description: 'Nano Banana 2 на базе Gemini с мировыми знаниями и поиском в реальном времени. Создавайте фактически точные и потрясающие изображения на сверхвысокой скорости.',
        twitter_title: 'Nano Banana 2 Генератор изображений | WeryAI',
        twitter_description: 'Nano Banana 2 на базе Gemini с мировыми знаниями и поиском в реальном времени. Создавайте фактически точные и потрясающие изображения на сверхвысокой скорости.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'AI-генератор изображений Nano Banana 2',
        twitterImageAlt: 'AI-генератор изображений Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling AI - Кинематографический генератор видео ИИ | WeryAI',
        description: 'Попробуйте Kling AI на WeryAI. Высококачественные результаты.',
        keywords: 'Kling AI, видео ИИ, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Генератор и редактор видео ИИ | WeryAI',
        description: 'Попробуйте Runway AI на WeryAI. Высококачественные результаты.',
        keywords: 'Runway AI, видео ИИ, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Генератор видео ИИ | WeryAI',
        description: 'Попробуйте Hailuo 2.3 на WeryAI. Высококачественные результаты.',
        keywords: 'Hailuo 2.3, видео ИИ, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Продвинутый генератор видео ИИ | WeryAI',
        description: 'Попробуйте Hailuo AI на WeryAI. Высококачественные результаты.',
        keywords: 'Hailuo AI, видео ИИ, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Генератор анимации ИИ | WeryAI',
        description: 'Попробуйте Pika 2.2 на WeryAI. Высококачественные результаты.',
        keywords: 'Pika 2.2, анимация ИИ, WeryAI',
    },
    seedance: {
        title: 'Seedance - Генератор видео танцев и движений ИИ | WeryAI',
        description: 'Попробуйте Seedance на WeryAI. Реалистичные и профессиональные результаты.',
        keywords: 'Seedance, видео ИИ, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Режиссёрский ИИ-генератор видео | WeryAI',

        description: 'Создавайте режиссёрские ИИ-видео с Werydance 2.0: мультимодальные ссылки, нарративная согласованность и физическая симуляция. Бесплатно на WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, ИИ генератор видео, режиссёрское видео, мультимодальное видео, физическая симуляция, синхронизация губ, текст в видео, бесплатное ИИ видео, WeryAI',

        og_title: 'Werydance 2.0 - Режиссёрский ИИ-генератор видео | WeryAI',

        og_description: 'Создавайте режиссёрские ИИ-видео с Werydance 2.0: мультимодальные ссылки, нарративная согласованность и физическая симуляция. Бесплатно на WeryAI.',

        twitter_title: 'Werydance 2.0 - Режиссёрский ИИ-генератор видео | WeryAI',

        twitter_description: 'Создавайте режиссёрские ИИ-видео с Werydance 2.0: мультимодальные ссылки, нарративная согласованность и физическая симуляция. Бесплатно на WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Бесплатно Nano Banana Pro - ИИ генератор изображений | WeryAI',
        description: 'Используйте Nano Banana Pro на WeryAI для ИИ-изображений высшего качества! Конкурирует с Midjourney по качеству. Бесплатные кредиты, карта не нужна.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google ИИ-изображения, reasoning ИИ, 4K ИИ изображение, Nano Banana Pro бесплатно, как использовать Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Бесплатно Nano Banana - ИИ генератор изображений | WeryAI',
        description: 'Используйте Nano Banana на WeryAI для лёгкого создания ИИ-изображений! Универсальная и быстрая модель для всех творческих задач. Бесплатные кредиты, карта не нужна.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google ИИ-изображения, быстрый ИИ генератор, согласованность персонажей, Nano Banana бесплатно, как использовать Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Бесплатно FLUX - Попробуйте ИИ-генератор | WeryAI',
        description: 'Используйте FLUX на WeryAI для создания потрясающих ИИ-изображений! Создан командой Stable Diffusion с исключительным качеством. Бесплатные кредиты, карта не нужна.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, ИИ генератор изображений, текст в изображение, ИИ-арт, FLUX бесплатно, как использовать FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Бесплатно FLUX Kontext - Про ИИ-редактор | WeryAI',
        description: 'Используйте FLUX Kontext на WeryAI для профессионального редактирования ИИ-изображений! Превосходная точность, типографика и многоэтапное редактирование. Бесплатные кредиты, карта не нужна.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, ИИ редактор изображений, профессиональные ИИ-изображения, типографика ИИ, FLUX Kontext бесплатно, как использовать FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Бесплатно Imagen 4 - Google ИИ-генератор | WeryAI',
        description: 'Используйте Google Imagen 4 на WeryAI для фотореалистичных ИИ-изображений! Универсальный контроль стилей и точная генерация текста. Бесплатные кредиты, карта не нужна.',
        keywords: 'Imagen 4, Google Imagen, Google ИИ генератор, текст в изображение, фотореалистичный ИИ, Imagen бесплатно, как использовать Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Бесплатно Qwen Image - ИИ модель Alibaba | WeryAI',
        description: 'Используйте Qwen Image на WeryAI для многоязычного ИИ-арта! Открытая модель Alibaba с превосходным рендерингом текста. Бесплатные кредиты, карта не нужна.',
        keywords: 'Qwen Image, Alibaba AI, открытый ИИ-генератор, многоязычный рендеринг текста, Qwen Image бесплатно, как использовать Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Бесплатно Wan AI - Генератор изображений Alibaba | WeryAI',
        description: 'Используйте Wan AI на WeryAI для ИИ-изображений высокой точности! Модель Alibaba с точным следованием подсказкам и фотореалистичным рендерингом. Бесплатные кредиты, карта не нужна.',
        keywords: 'Wan AI, Wan 2.5, Alibaba ИИ генератор, текст в изображение, фотореалистичный ИИ, Wan AI бесплатно, как использовать Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Бесплатно Seedream 4.0 - ByteDance ИИ-изображения | WeryAI',
        description: 'Используйте Seedream 4.0 на WeryAI для сверхбыстрой генерации ИИ-изображений! Модель ByteDance с разнообразными стилями. Бесплатные кредиты, карта не нужна.',
        keywords: 'Seedream, Seedream 4.0, ByteDance ИИ-изображения, сверхбыстрый ИИ, художественные стили ИИ, Seedream бесплатно, как использовать Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Бесплатно Dreamina 4.0 - Мультимодальный ИИ | WeryAI',
        description: 'Используйте Dreamina 4.0 на WeryAI для мультимодального создания ИИ-изображений! Эскиз в изображение, перенос стиля и слияние персонажей. Бесплатные кредиты, карта не нужна.',
        keywords: 'Dreamina 4.0, ByteDance ИИ-изображения, мультимодальный ИИ, эскиз в изображение, перенос стиля, Dreamina бесплатно, как использовать Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Бесплатно Seedream 4.5 - ByteDance ИИ-изображения | WeryAI',
        description: 'Используйте Seedream 4.5 на WeryAI для флагманской генерации ИИ-изображений! Новейшая модель ByteDance с точной типографикой. Бесплатные кредиты, карта не нужна.',
        keywords: 'Seedream 4.5, ByteDance ИИ-изображения, флагманский ИИ, рендеринг типографики, мульти-изображение, Seedream 4.5 бесплатно, как использовать Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Вершина ИИ генерации изображений | WeryAI',
        description: 'Seedream 5.0 — вершина ByteDance в области ИИ-визуализации с нативным качеством 8K, предельным семантическим пониманием, многосубъектной композицией и рендерингом текста 2.0. Попробуйте бесплатно на WeryAI.',
        keywords: 'Seedream 5.0, генерация изображений ИИ, качество 8K, семантическое понимание, многосубъектная композиция, рендеринг текста, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Вершина ИИ генерации изображений | WeryAI',
        og_description: 'Seedream 5.0 — вершина ByteDance в области ИИ-визуализации с нативным качеством 8K, предельным семантическим пониманием, многосубъектной композицией и рендерингом текста 2.0. Попробуйте бесплатно на WeryAI.',
        twitter_title: 'Seedream 5.0 Вершина ИИ генерации изображений | WeryAI',
        twitter_description: 'Seedream 5.0 — вершина ByteDance в области ИИ-визуализации с нативным качеством 8K, предельным семантическим пониманием, многосубъектной композицией и рендерингом текста 2.0. Попробуйте бесплатно на WeryAI.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'AI-генератор изображений Seedream 5.0',
        twitterImageAlt: 'AI-генератор изображений Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Профессиональный генератор векторной графики ИИ | WeryAI',
        description: 'Recraft V4 Vector — профессиональный генератор векторной графики ИИ от Recraft.ai, создающий редактируемые SVG-векторы с безупречным масштабированием, точной типографикой и контролем стиля бренда. Попробуйте бесплатно на WeryAI прямо сейчас.',
        keywords: 'Recraft V4 Vector, генерация векторов ИИ, генератор SVG, настоящий вектор, дизайн логотипа, иконки UI, векторная иллюстрация, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Бесплатно Midjourney - Попробуйте ИИ арт-генератор | WeryAI',
        description: 'Используйте Midjourney на WeryAI для художественных ИИ-изображений! Известен потрясающей эстетикой и качеством освещения. Бесплатные кредиты, карта не нужна.',
        keywords: 'Midjourney, Midjourney AI, ИИ арт-генератор, художественные ИИ изображения, Midjourney бесплатно, альтернатива Midjourney, как использовать Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Генератор видео ИИ | WeryAI',
        description: 'Создавайте потрясающие видео с Runway Gen-4.5 на WeryAI. Гибридная авторегрессивно-диффузионная архитектура для точной физической симуляции и временной согласованности.',
        keywords: 'Runway Gen-4.5, генератор видео ИИ, кинематографическое видео ИИ, физическая симуляция, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Генератор видео ИИ | WeryAI',
        description: 'Создавайте высококачественные видео с Kling 2.6 Pro на WeryAI. Нативная аудиовизуальная генерация, кинематографическое качество 1080p, превосходное следование подсказкам.',
        keywords: 'Kling 2.6 Pro, генератор видео ИИ, высококачественное видео ИИ, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Генератор видео Точный контроль камеры | WeryAI',
        description: 'Создавайте кинематографические видео ИИ с Dreamina 3.0 (Jimeng 3.0) на WeryAI. Точный контроль начальных/конечных кадров, профессиональные движения камеры и генерация видео 1080p высокой динамики.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, генератор видео ИИ, контроль камеры, начальные конечные кадры, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Генератор видео ИИ Креативная генерация | WeryAI',
        description: 'Раскройте свой творческий потенциал на WeryAI с генератором видео ИИ Kling O1. Идеально для создания воображаемого и уникального видеоконтента.',
        keywords: 'Kling O1, генератор видео ИИ, креативное видео ИИ, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Умный ИИ-генератор видео | WeryAI',

        description: 'Создавайте ИИ-видео с Kling 3.0: умная раскадровка, мультиязычная синхронизация губ и точный рендеринг текста. Бесплатно на WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, ИИ генератор видео, умная раскадровка, синхронизация губ, рендеринг текста, текст в видео, изображение в видео, бесплатное ИИ видео, WeryAI',

        og_title: 'Kling 3.0 - Умный ИИ-генератор видео | WeryAI',

        og_description: 'Создавайте ИИ-видео с Kling 3.0: умная раскадровка, мультиязычная синхронизация губ и точный рендеринг текста. Бесплатно на WeryAI.',

        twitter_title: 'Kling 3.0 - Умный ИИ-генератор видео | WeryAI',

        twitter_description: 'Создавайте ИИ-видео с Kling 3.0: умная раскадровка, мультиязычная синхронизация губ и точный рендеринг текста. Бесплатно на WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Нативное 16с аудио-видео ИИ | WeryAI',

        description: 'Генерируйте нативное 16-секундное аудио-видео с Vidu Q3: умный монтаж, точный рендеринг текста и мультиязычный липсинк. Бесплатно на WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, ИИ генератор видео, нативное 16с аудио-видео, умная раскадровка, рендеринг текста, синхронизация губ, текст в видео, изображение в видео, бесплатное ИИ видео, WeryAI',

        og_title: 'Vidu Q3 - Нативное 16с аудио-видео ИИ | WeryAI',

        og_description: 'Генерируйте нативное 16-секундное аудио-видео с Vidu Q3: умный монтаж, точный рендеринг текста и мультиязычный липсинк. Бесплатно на WeryAI.',

        twitter_title: 'Vidu Q3 - Нативное 16с аудио-видео ИИ | WeryAI',

        twitter_description: 'Генерируйте нативное 16-секундное аудио-видео с Vidu Q3: умный монтаж, точный рендеринг текста и мультиязычный липсинк. Бесплатно на WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Бесплатно GPT-4o - Генератор изображений OpenAI | WeryAI',
        description: 'Используйте GPT-4o на WeryAI для создания изображений через диалог! ИИ OpenAI с точным рендерингом текста. Бесплатные кредиты, карта не нужна.',
        keywords: 'GPT-4o, GPT-4o изображение, OpenAI генератор, разговорный ИИ-арт, GPT-4o бесплатно, как использовать GPT-4o, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Бесплатно GPT Image 1.5 - OpenAI арт-генератор | WeryAI',
        description: 'Используйте GPT Image 1.5 на WeryAI для ИИ-арта нового поколения! Новейшая модель OpenAI с улучшенной креативностью. Бесплатные кредиты, карта не нужна.',
        keywords: 'GPT Image 1.5, OpenAI модель изображений, ИИ арт-генератор, ИИ нового поколения, GPT Image 1.5 бесплатно, как использовать GPT Image 1.5, WeryAI',
    },
}
